import * as THREE from "three";
import { inputKind } from "./interactionPolicy";

function worldPose(pose, player) {
  if (!pose) return null;
  const matrix = new THREE.Matrix4().fromArray(pose.transform.matrix).premultiply(player.matrixWorld);
  const position = new THREE.Vector3();
  const rotation = new THREE.Quaternion();
  matrix.decompose(position, rotation, new THREE.Vector3());
  return { position, rotation, matrix };
}

export function readSource(frame, source, referenceSpace, player) {
  const kind = inputKind(source);
  const result = { inputSource: source, kind, tracked: false, ray: null, grip: null, joints: {} };
  try {
    result.ray = worldPose(frame.getPose(source.targetRaySpace, referenceSpace), player);
    if (source.gripSpace) result.grip = worldPose(frame.getPose(source.gripSpace, referenceSpace), player);
    if (source.hand) {
      for (const name of ["wrist", "index-finger-metacarpal", "pinky-finger-metacarpal", "index-finger-tip"]) {
        const joint = source.hand.get(name);
        result.joints[name] = joint ? worldPose(frame.getJointPose(joint, referenceSpace), player) : null;
      }
    }
    result.tracked = !!result.ray && (kind !== "hand" || !!result.joints.wrist);
    if (result.ray) result.ray.direction = new THREE.Vector3(0, 0, -1).applyQuaternion(result.ray.rotation);
  } catch (_) { result.tracked = false; }
  return result;
}

export function readFrame(frame, session, referenceSpace, player) {
  if (!frame || !referenceSpace || !session || session.visibilityState !== "visible") return null;
  try {
    player.updateWorldMatrix(true, false);
    const viewer = worldPose(frame.getViewerPose(referenceSpace), player);
    if (!viewer) return null;
    return {
      head: viewer.position,
      forward: new THREE.Vector3(0, 0, -1).applyQuaternion(viewer.rotation),
      inputs: Array.from(session.inputSources).map((source) => readSource(frame, source, referenceSpace, player)),
      time: performance.now(),
    };
  } catch (_) { return null; }
}

export function watchSample(source, data) {
  if (!source || source.kind !== "hand") return null;
  const { wrist, "index-finger-metacarpal": index, "pinky-finger-metacarpal": pinky } = source.joints;
  if (!wrist || !index || !pinky) return null;
  return {
    wrist: wrist.position, index: index.position, pinky: pinky.position,
    // WebXR hand joints define -Y as the outward palm normal; +Y is dorsal.
    dorsal: new THREE.Vector3(0, 1, 0).applyQuaternion(wrist.rotation),
    head: data.head, forward: data.forward,
  };
}
